import { useState, useEffect } from "react";

import { useDispatch } from 'react-redux'
import { GetStaticContent } from "../../features/auth/authSlice";
import FooterStatic from "../../components/FooterStatic";
import { toast } from 'react-hot-toast';
import ShimmerLoader from "../../components/ShimmerLoader";

export default function Faq() {

  const dispatch = useDispatch()
  const [Processing, setProcessing] = useState(true);
  const [PageData, setPageData] = useState([]);
  const pageurl = {
    pageurl: 'faq'
  }
  const GetPageData = async () => {
    const response = await dispatch(
      GetStaticContent({ pageurl })
    ).unwrap();
    const { data } = response;
    if (data.status.success) {
      setPageData(data?.data || [])
      setProcessing(false)
    } else {
      setProcessing(false)
      toast.error(data.message, { autoClose: 2000 });
    }
  }
  useEffect(() => {
    if (pageurl) {
      GetPageData()
    }
  }, [dispatch]);
  return (
    <>

      <div className="font-sans text-gray-800">
        <div className="w-full">
          <img
            src={PageData?.background_image || "/placeholder.png"} // Replace with your image property
            alt="About Us"
            onError={(e) => (e.target.src = "/placeholder.png")}
            className="w-full mt-2 h-[200px] sm:h-80 md:h-[180px] object-cover  shadow-md"
          />
        </div>
        <section className="bg-white px-6 py-8 mb-4">
          <div className="container mx-auto px-4 flex flex-wrap items-center">
            <div className="flex flex-col ">
              {/* Content Below */}
              <div className="w-full">
                <h2 className="text-2xl font-bold mb-4">FAQ</h2>

                {Processing ? (
                  <div className="space-y-2">
                    <ShimmerLoader />
                    <ShimmerLoader />
                    <ShimmerLoader />
                    <ShimmerLoader />
                    <ShimmerLoader />
                  </div>
                ) : (
                  <div
                    className="text-gray-700 prose max-w-none"
                    dangerouslySetInnerHTML={{ __html: PageData?.content }}
                  />
                )}
              </div>

            </div>
          </div>
        </section>

        <FooterStatic />
      </div>

    </>
  );
}

